import enrollCmd from "../base/enrollCmd";
import bioFinger from "../base/bioFinger";
import bioEnrollDeviceType from "../base/bioEnrollDeviceType";
import bioConsolidate from "../base/bioConsolidate";

/**
 * Nothing to fancy here, just checks input values and builds the JSON to send to plugin manager
 * @param consolidated 
 * @param finger 
 * @param enrollForDeviceType 
 */
export const enrollControlIdMsgIdBio = (consolidated?, finger?, enrollForDeviceType?) => {
    const consolidate = consolidated ? consolidated : bioConsolidate.CONSOLIDATE_TRUE;
    const fingerSelected = finger ? finger : bioFinger.UNKNOWN_FINGER;
    const enrollDeviceType = enrollForDeviceType ? enrollForDeviceType : bioEnrollDeviceType.SINGLE;
    const enrolMessage = "{'enrollType':'" + enrollCmd.CMD_CONTROLID + "','consolidate':'" + consolidate + "','finger':'" + fingerSelected + "','enrollForDeviceType':'" + enrollDeviceType + "'}";
    return enrolMessage;
};

/**
  * converts the message to object type.
  * @param {*} obj
  */
export const decodeControlIdPluginMsg = (obj) => {
    // TODO
};